<template>
  <div class="modal__cover image-modal" @click.self="onClickModalCover">
    <div class="modal__content">
      <div class="modal__image">
        <img v-lazy="imageUrl" alt="design" />
      </div>
      <div class="modal__descriptions">
        <div class="modal__btn">
          <div class="modal__btn--primary">
            <button
              type="button"
              class="btn btn--primary"
              @click="onClickPrimaryButton"
            >
              {{ primaryButtonText }}
            </button>
          </div>
          <div class="modal__btn--cancel">
            <span @click="onClickCancelButton">{{ cancelButtonText }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    primaryButtonText: {
      type: String,
      required: true
    },
    cancelButtonText: {
      type: String,
      required: true
    }
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickPrimaryButton() {
      this.$emit('clicked-primary')
    },
    onClickCancelButton() {
      this.$emit('clicked-cancel')
    }
  }
}
</script>
